import { EffectCallback, useCallback, useEffect, useRef } from 'react';

export const useInitialMount = () => {
  const isFirst = useRef(true);

  if (isFirst.current) {
    // eslint-disable-next-line immutable/no-mutation
    isFirst.current = false;
    return true;
  }

  return false;
};

export const useOnMount = (effect: EffectCallback) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(effect, []);
};

export const useMountedState = (): (() => boolean) => {
  const mountedRef = useRef<boolean>(false);

  useEffect(() => {
    // eslint-disable-next-line immutable/no-mutation
    mountedRef.current = true;

    return () => {
      // eslint-disable-next-line immutable/no-mutation
      mountedRef.current = false;
    };
  }, []);

  return useCallback(() => mountedRef.current, []);
};
